<template>
  <div class="row">
    <SideMenu v-bind:slt="10" />
    <div class="right-column">
      <TopBar />
      <main class="main-content p-5" role="main">
        <div class="row">
          <div class="col-md-12">
            <h1>Ordenes</h1>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-lg-10">
                  {{ order.consumo }}
                  <OrderConsumo title="Local" v-bind:order="order" />
                  <p
                    v-show="order.consumo == 'sucursal'"
                    class="task-list-stats"
                  >
                    <span class="task-list-total">Mesas Activas: </span>
                    {{ this.pendientesLocal }}
                  </p>
                  <p
                    v-show="order.consumo == 'domicilio'"
                    class="task-list-stats"
                  >
                    <span class="task-list-total">Entregas pendientes: </span>
                    {{ this.pendientesEntrega }}
                  </p>
                  <p
                    v-show="order.consumo == 'llevar'"
                    class="task-list-stats"
                  >
                    <span class="task-list-total">Para llevar pendientes: </span>
                    {{ this.pendientesLlevar }}
                  </p>
                  <p
                    v-show="order.consumo == 'recoger'"
                    class="task-list-stats"
                  >
                    <span class="task-list-total">Para recoger pendientes: </span>
                    {{ this.pendientesRecoger }}
                  </p>
                </div>
                <div v-if="false" class="col d-flex " style="align-items:center;justify-content:center">
                  <button
                    v-show="order.consumo == 'sucursal'"
                    class="btn btn-secondary agregar"
                    type="button"
                    @click="agregarMesa"
                  >
                    Agregar
                  </button>
                </div>
              </div>
            </div>
            <div v-show="order.consumo == 'sucursal'" class="row">
              <div class="card-body">
                <div class="container">
                  <transition-group name="ordenes" tag="div" class="row">
                    <OrderBoxLocal
                      :key="ordenes.ordenId"
                      v-for="(ordenes, index) in localFaltantes"
                      v-model="localFaltantes[index]"
                      @click="onOrderInfo"
                    />
                  </transition-group>
                </div>
              </div>
            </div>
            <div v-show="order.consumo == 'domicilio'" class="row">
              <div class="card-body">
                <transition-group name="ordenes" tag="div" class="order-flex">
                  <OrderBoxEntrega
                    :key="index"
                    v-for="(ordenes, index) in entregasFaltantes"
                    v-model="entregasFaltantes[index]"
                    @click="onOrderInfo"
                  />
                </transition-group>
              </div>
            </div>
            <div v-show="order.consumo == 'llevar'" class="row">
              <div class="card-body">
                <transition-group name="ordenes" tag="div" class="order-flex">
                  <OrderBoxLlevar
                    :key="index"
                    v-for="(ordenes, index) in llevarFaltantes"
                    v-model="llevarFaltantes[index]"
                    @click="onOrderInfo"
                  />
                </transition-group>
              </div>
            </div>
            <div v-show="order.consumo == 'recoger'" class="row">
              <div class="card-body">
                <transition-group name="ordenes" tag="div" class="order-flex">
                  <OrderBoxRecoger
                    :key="index"
                    v-for="(ordenes, index) in recogerFaltantes"
                    v-model="recogerFaltantes[index]"
                    @click="onOrderInfo"
                  />
                </transition-group>
              </div>
            </div>
          </div>
          <div class="modal fade" id="detallesOrden" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" style="width:100%">
                <!--Header-->
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Detalles de la Orden</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" tabindex="-1">
                    <span aria-hidden="true">×</span>
                    </button>
                </div>
                <!--Body-->
                <div class="modal-body">                                                                                                    
                    <div class="col-lg-12" v-if="currentOrden.tipo == 'sucursal'">
                      <div class="order-body">
                        <strong>Orden: </strong> <span>{{ currentOrden.info.ordenId }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Mesa: </strong> <span>{{ currentOrden.info.mesa }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Total: </strong> <span>$  {{ currentOrden.info.total }}.00</span>
                      </div>
                    </div>
                    <div class="col-lg-12" v-if="currentOrden.tipo == 'domicilio'">
                      <div class="order-body">
                        <strong>Orden: </strong> <span>{{ currentOrden.info.ordenId }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Colonia: </strong> <span>{{ currentOrden.info.colonia }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Calle: </strong> <span>{{ currentOrden.info.calle }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Número Exterior: </strong> <span>{{ currentOrden.info.numeroExt }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Número Interior: </strong> <span>{{ currentOrden.info.numeroInt }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Total: </strong> <span>$  {{ currentOrden.info.total }}.00</span>
                      </div>
                    </div> 
                    <div class="col-lg-12" v-if="currentOrden.tipo == 'llevar'">
                      <div class="order-body">
                        <strong>Orden: </strong> <span>{{ currentOrden.info.ordenId }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Nombre del Cliente: </strong> <span>{{ currentOrden.info.nombreCliente }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Total: </strong> <span>$  {{ currentOrden.info.total }}.00</span>
                      </div>
                    </div> 
                    <div class="col-lg-12" v-if="currentOrden.tipo == 'recoger'">
                      <div class="order-body">
                        <strong>Orden: </strong> <span>{{ currentOrden.info.ordenId }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Nombre del Cliente: </strong> <span>{{ currentOrden.info.nombreCliente }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Teléfono: </strong> <span>{{ currentOrden.info.telefonoCliente }}</span>
                      </div>
                      <div class="order-body">
                        <strong>Total: </strong> <span>$  {{ currentOrden.info.total }}.00</span>
                      </div>
                    </div>
                </div>
                <!--Footer-->
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" style="margin: 0px;" @click="onCartChange()">Aceptar</button>
                </div>
                </div>
            </div>
            </div>
          <!-- End Card div-->
          
            <!-- <div class="card" style="margin-top: 45px">
              <div class="card-header">
                <div class="row">
                  <div class="col">
                    Entrega
                    <p class="task-list-stats">
                      <span class="task-list-total">Entregas Pendientes: </span>
                      {{ this.pendientesEntrega }}.
                    </p>
                  </div>
                  <div class="col" style="align-items: center">
                    <button
                      class="btn btn-primary agregar"
                      type="button"
                      @click="agregarEntrega"
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            </div> -->
          
        </div>
      </main>
    </div>
  </div>
</template>

<script>
/*imports*/

import SideMenu from "@/components/SideMenu.vue";
import TopBar from "@/components/TopBar.vue";
import OrderConsumo from "@/components/Restaurant/Heris/Order/ConsumoCheck.vue";
import OrderBoxLocal from "@/components/OrderBoxLocal.vue";
import OrderBoxEntrega from "@/components/OrderBoxEntrega.vue";
import OrderBoxLlevar from "@/components/OrderBoxLlevar.vue";
import OrderBoxRecoger from "@/components/OrderBoxRecoger.vue";

import ResOrdenes from "@/modules/restaurant/models/ResOrdenes.js";
import Sucursal from '@/modules/restaurant/models/Sucursal.js';

export default {
  name: "catalogos",
  mounted() {
    let _this = this;
    $('[data-toggle="tooltip"]').tooltip()
    var sid = Sucursal.getSucursal()
    if(sid == null){
      console.log("error en sucursal")
    }else{
      ResOrdenes.listAbiertas(sid.idSucursal, function (res) {
        console.log(res);
        _this.items = res.data.items;
        _this.loadOrdenesLocal();
        _this.loadOrdenesEntrega();
        _this.loadOrdenesLlevar();
        _this.loadOrdenesRecoger();
      });
    }
  },
  data() {
    return {
      order: {
        consumo: "sucursal",
      },
      currentOrden: {
        info : null,
        tipo : "",
      },
      items: [],
      ordenesLocal: [],
      ordenesEntrega: [
        {
          id: 3,
          colonia: "Jardines",
          calle: "Blvd. de las Rosas",
          total: 6000,
          atendido: false,
        },
      ],
      ordenesLlevar:[],
      ordenesRecoger:[],
      pendientesLocal: 0,
      pendientesEntrega: 0,
      pendientesLlevar: 0,
      pendientesRecoger: 0,
    };
  },
  components: {
    SideMenu,
    TopBar,
    OrderConsumo,
    OrderBoxLocal,
    OrderBoxEntrega,
    OrderBoxLlevar,
    OrderBoxRecoger,
  },
  computed: {
    localFaltantes() {
      let c = this.ordenesLocal.filter((exp) => !exp.atendido);
      this.pendientesLocal = c.length;
      c.sort(this.orderSort)
      return c;
    },
    entregasFaltantes() {
      let c = this.ordenesEntrega.filter((exp) => !exp.atendido);
      this.pendientesEntrega = c.length;
      c.sort(this.orderSort)
      return c;
    },
    llevarFaltantes() {
      let c = this.ordenesLlevar.filter((exp) => !exp.atendido);
      this.pendientesLlevar = c.length;
      c.sort(this.orderSort)
      return c;
    },
    recogerFaltantes() {
      let c = this.ordenesRecoger.filter((exp) => !exp.atendido);
      this.pendientesRecoger = c.length;
      c.sort(this.orderSort)
      return c;
    },
  },
  methods: {
    loadOrdenesLocal() {
      let _this = this;
      _this.ordenesLocal = [];
      _this.items.forEach((item) => {
        if (item.consumo==='sucursal') {
          _this.ordenesLocal.push({
            ordenId: item.ordenId,
            mesa: item.mesa,
            total: item.total,
            folio:item.folio,
            atendido: false,
          });
        }
      });
    },
    orderSort(a, b){
      return a.ordenId-b.ordenId;
    },
    loadOrdenesEntrega() {
      let _this = this;
      _this.ordenesEntrega = [];
      _this.items.forEach((item) => {
        if (item.consumo==='domicilio') {
          _this.ordenesEntrega.push({
            ordenId: item.ordenId,
            mesa: item.mesa,
            total: item.total,
            atendido: false,
            calle:item.calle,
            numeroExt: item.numeroExt,
            numeroInt: item.numeroInt,
            colonia:item.colonia,
            folio:item.folio,
            cobroEnvio: item.cobroEnvio,
          });
        }
      });
    },
    loadOrdenesLlevar() {
      let _this = this;
      _this.ordenesLlevar = [];
      _this.items.forEach((item) => {
        if (item.consumo==='llevar') {
          _this.ordenesLlevar.push({
            ordenId: item.ordenId,
            folio:item.folio,
            mesa: item.mesa,
            nombreCliente: item.nombreCliente,
            total: item.total,
            atendido: false,
            
          });
        }
      });
    },
    loadOrdenesRecoger() {
      let _this = this;
      _this.ordenesRecoger = [];
      _this.items.forEach((item) => {
        if (item.consumo==='recoger') {
          _this.ordenesRecoger.push({
            ordenId: item.ordenId,
            mesa: item.mesa,
            total: item.total,
            folio:item.folio,
            atendido: false,
            nombreCliente: item.nombreCliente,
            telefonoCliente: item.telefonoCliente
          });
        }
      });
    },
    agregarMesa() {
      //   this.ordenesLocal.push({ mesa: Math.floor(Math.random()*100), total: 2500, atendido: false});
      this.$router.push({ name: "ResHerisOrdenesEdit" });
    },
    agregarEntrega() {
      this.ordenesEntrega.push({
        id: Math.floor(Math.random() * 100),
        colonia: "Centro",
        calle: "20 de Noviembre",
        total: 2500,
        atendido: false,
      });
    },
    onOrderInfo(orden, tipo){
      this.currentOrden.info = orden
      this.currentOrden.tipo = tipo
      console.log(this.currentOrden)
      $('#detallesOrden').modal('show');
    },
    onCartChange(){
      $('#detallesOrden').modal('hide');
    },
  },
};
</script>

<style scoped>
.ordenes-move {
  transition: transform 1s;
}

.ordenes-leave-active {
  position: relative;
}

.ordenes-enter-active {
  animation: fade 1s;
}

.ordenes-leave-to {
  opacity: 0;
}

.ordenes-active {
  position: relative;
}

@keyframes fade {
  from {
    opacity: 0%;
  }
  to {
    opacity: 100%;
  }
}

.order-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 15px;
}

.agregar {
  min-width: 150px;
}

.order-body {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  font-size: 16px;
  border-bottom: 1px lightgray solid;
  padding: 5px;
  padding-bottom: 10px;
}

.order-body:last-child{
  border-bottom: 0px lightgray solid;
}
</style>